import { useCheckPermissions } from '@/shared';
import { SaveProveedores } from '../../shared/components/saveProveedores';
import { PermissionsEnum } from '@/auth/interfaces';

export type CreateProveedoresPageProps = {};

const CreateProveedoresPage: React.FC<CreateProveedoresPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_proveedor)
  return <SaveProveedores titlePage="Crear Proveedor" />;
};

export default CreateProveedoresPage;
